passwordRecovery = {}


passwordRecovery.process = function (reCaptchaEnabled) {

    let captchaValidator = null;

    // Setup captcha validation if required
    if (reCaptchaEnabled) {
        captchaValidator = Common.validateCaptcha(".frc-captcha");
        captchaValidator.bindEvents();
    }

    Common.attachEventToElements('#recoverDetailsForm', 'submit', function (event) {

        let invalidInput = false;
        const errorMessage = $("#error-msg");
        errorMessage.hide();

        const usernameInput = document.getElementById("usernameUserInput");
        const usernameHidden = document.getElementById("username");

        const trimmedValue = usernameInput.value.trim();
        usernameInput.value = trimmedValue;

        const patternMatch = Common.validateField(
            trimmedValue,
            usernameInput.getAttribute("patternName")
        );

        // Username validation
        if (!trimmedValue) {
            Common.showElems([$('#usernameUserInput-error-missing-value')]);
            Common.hideElems([$('#usernameUserInput-error-pattern')]);
            invalidInput = true;
        } else if (!patternMatch) {
            Common.showElems([$('#usernameUserInput-error-pattern')]);
            Common.hideElems([$('#usernameUserInput-error-missing-value')]);
            invalidInput = true;
        } else {
            usernameHidden.value = trimmedValue;
        }

        // Captcha validation
        if (reCaptchaEnabled) {
            if (!captchaValidator.isValid) {
                Common.showElems([$('#g-recaptcha-error-missing-value')]);
                invalidInput = true;
            } else {
                Common.hideElems([$('#g-recaptcha-error-missing-value')]);
            }
        }

        if (invalidInput) {
            event.preventDefault();
        }
    });
};

